import React from 'react';
import Referees from 'components/general/Referees'

/*const getConfigForReferees = () => {
    let config = {
        header: 'Referees',
        source: 'official'
    }
    return config   
}*/

const Bk3Referees = ({data}) => {

     //const refereesConf = getConfigForReferees();
    
     //consoleLog(data?.results?.officials);
     return (
      <div className="container">
          <div className="row">
              <div className="col-12">
                  {data?.results?.officials &&
                      <Referees data={data?.results?.officials}  /*config={refereesConf}*/ />
                  }
              </div>
          </div>
      </div>
    );

}

export default Bk3Referees;